<template>
  <div class="public-view">
    <!-- 公共留言区标题 -->
    <div class="public-title">
      <img src="../assets/shouye/public-title.png" alt="公共留言区">
    </div>

    <!-- 留言输入框 -->
    <div class="public-box">
      <textarea v-model="content" placeholder="请在此写下对老师的祝福……"></textarea>
    </div>

    <!-- 提交按钮 -->
    <div class="submit-wrap">
      <img src="../assets/shouye/submit.png" alt="提交" @click="submit">
    </div>

    <!-- 提示图 -->
    <div class="tips">
      <img src="../assets/shouye/tips.png" alt="留言提示">
    </div>
  </div>
</template>

<script>
	import { Toast } from 'vant'
export default {
  name: 'PublicMessage',
  props: {
    submitting: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      content: ''
    }
  },
  methods: {
    submit () {
      if (this.submitting) return
      const text = this.content.trim()
      if (!text) {
        Toast('请先填写留言内容')
        return
      }
      this.$emit('submit', text)
    },
    clear () {
      this.content = ''
    }
  }
}
</script>

<style scoped>
	.public-view{
		background: url("../assets/shouye/public-box.png") no-repeat center / 100% 100%;
		padding: 40px 15px 20px;
		margin: 0 5px;
		margin-top: 30px;
	}
.public-title {
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
}

.public-title img {
  width: 55%;
}

.public-box {
  
  padding: 10px 15px 0;
}

.public-box textarea {
  width: 100%;
  height: 150px;
  border-radius: 5px;
  padding: 5px;
  border: 1px solid #781a00;
  outline: none;
  resize: none;
  background: transparent;
  font-size: 15px;
  line-height: 1.8;
  color: #8a4a2a;
  font-family: inherit;
}

.submit-wrap {
  display: flex;
  justify-content: center;
  margin: 10px 0 30px;
}

.submit-wrap img {
  width: 35%;
  cursor: pointer;
}

.tips {
  display: flex;
  justify-content: center;
  margin-bottom: 34px;
}

.tips img {
  width: 88%;
}
</style>
